<template>
  <div id="app">
    <router-view />

    <SearchWindow :windowWidth="windowWidth"></SearchWindow>
    <PictureWindow :windowWidth="windowWidth"></PictureWindow>
    <SideMenu></SideMenu>
  </div>
</template>

<script>
import SearchWindow from "@/components/SearchWindow/SearchWindow.vue";
import PictureWindow from "@/views/Picture/PictureWindow/PictureWindow.vue";
import SideMenu from "@/components/SideMenu/SideMenu.vue";
export default {
  components: {
    SearchWindow,
    PictureWindow,
    SideMenu
  },
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0
    };
  },
  methods: {
    handleAppResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;

      setTimeout(() => {
        if (this.$refs.pictureList) {
          this.maxArrange = Math.floor(
            this.$refs.pictureList.offsetWidth / 240
          );
          this.maxArrange = this.maxArrange <= 1 ? 2 : this.maxArrange;
          if (!this.initFlag) {
            this.reset();
          }
        }
      }, 30);
    }
  },
  mounted() {
    this.handleAppResize();
    window.addEventListener("resize", this.handleAppResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleAppResize);
  }
};
</script>

<style lang="scss">
* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f7f9fe;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(153, 171, 203, 0.5);
    background-clip: content-box;
    border-radius: 10px;

    &:hover {
      background-color: #99abcb;
    }
  }
}

html {
  background-color: #f7f9fe;

  @media (max-width: 800px) {
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
}

body {
  background-color: #f7f9fe;
  padding: 0;
  margin: 0;

  @media (max-width: 800px) {
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
}

#app {
  background-color: #f7f9fe;
}

ul,
ol,
nav {
  list-style: none;
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
  padding: 0;
}

input {
  font-family: inherit;
}

button {
  outline: none;
  border: 0;
  background-color: transparent;
  font-size: 16px;
  cursor: pointer;
  font-family: inherit;

  &:active {
    opacity: 0.7;
  }
}

a {
  text-decoration: none;
  color: #000;
  -webkit-tap-highlight-color: transparent;
  /* Safari */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* Android */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently not supported by any browser */
}

a:hover,
a:visited,
a:link,
a:active {
  color: #000;
}

.scrollbar_y_main {
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 10px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background: #dbdbdb;
    background-clip: content-box;
    border-radius: 10px;
  }
}

.background_main {
  box-sizing: border-box;
  border-radius: 15px;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #ebeef5;
}
</style>
